export const groups: IGroups = [
  {
    id: 'base',
    name: 'Parts',
    itemsCount: 0,
  },
];
